// 탭메뉴 컴포넌트로 사용 가능합니다.
import React, { useState } from "react"
import styled from "styled-components"
import F1floor from "./shopFloor/F1floor"
import F2floor from "./shopFloor/F2floor"
import F3floor from "./shopFloor/F3floor"
import F4floor from "./shopFloor/F4floor"



const FloorButton = styled.button`
   width: 25%; padding: 10px 0 ; margin: 50px 0;
   border-top:  1px solid #ccc; border-bottom:  1px solid #ccc;
   border-left: none; border-right: none;
   color: ${(props) => (props.isActive ? "#db321c" : "#666")};
   background-color: ${(props) => (props.isActive ? "#f0f0f0" : "#fff")};
   cursor: pointer;  transition: .5s;
   font-size: 20px; font-family: 'Dai Banna SIL', serif;
`

const Shop = () => {
   const tab = ["1F", "2F", "3F", "4F"]
   const [activeTab, setActiveTab] = useState(tab[0])

   const handleTabClick = (tab) => {
      setActiveTab(tab)
   }

   return (
      <div id='Shop'>
         <div className="inner">
            <h1>Floor Guide</h1>
            <div style={{display:"flex", justifyContent:"space-between"}}>
               {tab.map((tabItem) => (
                  <FloorButton key={tabItem} onClick={() => handleTabClick(tabItem)} isActive={activeTab === tabItem}>
                     {tabItem}
                  </FloorButton>
               ))}
            </div>
         </div>

         <div className="inner">
            {activeTab === "1F" && <section><F1floor/></section>}
            {activeTab === "2F" && <section><F2floor/></section>}
            {activeTab === "3F" && <section><F3floor/></section>}
            {activeTab === "4F" && <section><F4floor/></section>}
         </div>
      </div>
   )
}

export default Shop
